// extracted by mini-css-extract-plugin
module.exports = {"tabDropdown":"style__tabDropdown__ROFNV","buttons":"style__buttons__HRlOm"};